import { Endpoint } from '../endpoint';

export const SourceFieldMappingView = new Endpoint('source_field_mapping_view');
